import React from 'react';

import { Grid, RadioButton, Text } from '@lp/ds-next';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import { map } from 'lodash/fp';

import {
  IPartnerV3,
  IPartnerV3Update,
  Languages,
} from '../../../models/partnerV3';
import { languages } from '@/configs/languages';

const LanguagesManagement = ({
  partner,
  updatePartner,
}: {
  partner: IPartnerV3;
  updatePartner: (
    data: Partial<IPartnerV3Update>
  ) => Promise<{ success: boolean }>;
}) => (
  <Grid item mobile={12} tablet={4}>
    <FormControl component="fieldset" variant="standard">
      <FormLabel component="legend">
        <Text variant="titleM">BOX Languages Management</Text>
      </FormLabel>
      <FormGroup sx={{ padding: '1rem' }}>
        <RadioGroup
          value={partner.product_default_language}
          name="product_default_language"
        >
          {map(
            (lang) => (
              <RadioButton
                key={lang}
                label={languages[lang.slice(-2)]}
                value={lang}
                checked={lang === partner.product_default_language}
                onChange={() =>
                  updatePartner({ product_default_language: lang })
                }
              />
            ),
            Languages
          )}
        </RadioGroup>
      </FormGroup>
    </FormControl>
  </Grid>
);

export default LanguagesManagement;
